export default "__VITE_ASSET__$4H3l4AN__"